<template>
    <div>
        <SoliForm
            v-if="purchaseOption"
            ref="form"
            title="Edit Membership"
            textSubtitle="Immediately update this membership's price and lesson duration. Lessons attached to this membership will still need to be updated according to the new membership duration."
            :text="
                chargeProration && proration != 0
                    ? `${proration > 0 ? 'Charge' : 'Credit'} ${adjustAmount}`
                    : 'Submit'
            "
            :saveChanges="purchaseOption.price.id !== selectedPrice.id"
            @reset="$emit('reset')"
            @submit="submit()"
        >
            <template #body>
                <v-skeleton-loader
                    v-if="loading"
                    type="list-item@3"
                    max-width="300"
                    class="mx-auto"
                ></v-skeleton-loader>
                <!--<div class="soli-grey py-3 font-bold">
                When should this change happen?
            </div>
            <SoliDate
                v-model="start"
                future
                :max="globalMomentEndOfMonth(new Date())"
                :min="globalMomentISOStartOfMonth(new Date())"
            ></SoliDate>-->
                <v-btn-toggle
                    v-model="selectedPrice"
                    mandatory
                    class="flex-col w-full"
                    v-if="!loading"
                    @change="getProration()"
                >
                    <v-list>
                        <v-list-item
                            v-for="option in priceOptions"
                            :key="option.id"
                        >
                            <SoliBtn
                                :value="option"
                                block
                                outlined
                                color="soli-grey"
                                class="mb-3"
                                >{{
                                    `${option.duration} min at ${option.formatAmount}`
                                }}</SoliBtn
                            ></v-list-item
                        ></v-list
                    >
                </v-btn-toggle>

                <v-container
                    v-if="purchaseOption.price.id !== selectedPrice.id"
                >
                    <v-row
                        class="soli-grey px-1"
                        no-gutters
                        v-if="chargeProration"
                    >
                        {{
                            proration > 0
                                ? "Proration Amount:"
                                : "Account Credit:"
                        }}
                        <div v-if="!prorationLoading" class="mx-2">
                            {{ adjustAmount }}
                        </div>
                        <v-progress-circular
                            v-if="prorationLoading"
                            indeterminate
                            :size="25"
                            color="primary"
                            class="mx-3"
                        ></v-progress-circular> </v-row
                    ><v-card-subtitle
                        class="px-1"
                        v-if="proration > 0 && chargeProration"
                        >This amount will be charged immediately to the credit
                        card on file.</v-card-subtitle
                    ><v-card-subtitle
                        class="px-1"
                        v-if="proration < 0 && chargeProration"
                        >This amount will be credited toward the next
                        invoice.</v-card-subtitle
                    ><v-switch
                        :label="
                            proration > 0
                                ? 'Charge Proration'
                                : 'Credit Balance'
                        "
                        v-model="chargeProration"
                        @change="prorationWarning = !$event"
                    ></v-switch
                ></v-container>
                <SoliChoice
                    v-if="prorationWarning && $refs.form.dialog"
                    @reset="closeModal(() => (prorationWarning = false))"
                    title="Are you sure?"
                    subtitle="This will skip prorating the current month."
                    warning
                    permanent
                    button1="I understand"
                    button2="Nevermind"
                    @option2="chargeProration = true"
                />
            </template>
        </SoliForm>
        <SoliChoice
            v-if="freeMembershipAlert"
            title="Uh Oh"
            subtitle="$0 memberships are unable to be changed. Please cancel this membership and sell a new one."
            button1="Okay"
            @reset="$emit('reset')"
            permanent
        />
    </div>
</template>

<script>
import globalMoment from "../../Mixins/GlobalMoment";

export default {
    mixins: [globalMoment],
    props: {
        purchaseOption: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            priceOptions: null,
            selectedPrice: {},
            proration: 0,
            loading: false,
            prorationLoading: false,
            proration: null,
            start: this.globalMomentISO(new Date()),
            chargeProration: true,
            prorationWarning: false,
        };
    },
    methods: {
        submit() {
            this.$inertia.put(
                route("subscription.change"),
                {
                    option: this.purchaseOption.id,
                    price: this.selectedPrice.stripe_id,
                    proration: Number(this.proration),
                    starts_at: this.start,
                    chargeProration: this.chargeProration,
                },
                {
                    onSuccess: () => {
                        this.$emit("success");
                        this.$refs.form.reset();
                    },
                    onError: () => {
                        this.$refs.form.loading = false;
                    },
                }
            );
        },
        getProration() {
            this.prorationLoading = true;
            axios
                .get(
                    route("proration", {
                        price: this.selectedPrice.unit_amount,
                        notice: Number(false),
                        anchor: this.purchaseOption.cycle,
                        originalPrice: this.purchaseOption.price.unit_amount,
                        starts_at: this.start,
                        alwaysProrate: 1,
                    })
                )
                .then((e) => {
                    this.proration = e.data.toFixed(2); // don't use floating points for money
                    this.prorationLoading = false;
                });
        },
        getPrices() {
            this.loading = true;
            axios
                .get(`/api/purchase-option/${this.purchaseOption.id}/prices`)
                .then((resp) => {
                    this.priceOptions = resp.data;
                    this.loading = false;

                    this.selectedPrice =
                        this.priceOptions.find(
                            (e) => e.id === this.purchaseOption.price.id
                        ) ?? this.purchaseOption.price;
                });
        },
    },
    computed: {
        adjustAmount() {
            return this.formatUnitAmount(
                this.proration * (this.proration > 0 ? 1 : -1)
            );
        },
        freeMembershipAlert() {
            return false;
            return this.purchaseOption.price.unit_amount === 0;
        },
    },
    mounted() {
        this.getPrices();
    },
};
</script>

<style></style>
